import React from 'react';

const colorMap = {
  accent: 'bg-accent/10 text-accent',
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/10 text-warning',
  error: 'bg-error/10 text-error',
  info: 'bg-info/10 text-info',
  gray: 'bg-blue-gray-100 text-blue-gray-500',
};

/**
 * Badge - Composant pour afficher un badge coloré (statut, label, etc.).
 *
 * @param {Object} props
 * @param {string} [props.color] - Couleur du badge ('success', 'error', etc.)
 * @param {React.ReactNode} props.children - Contenu du badge
 * @returns {JSX.Element}
 *
 * @example
 * <Badge color="success">Validé</Badge>
 */
export default function Badge({ color = 'accent', children, className = '' }) {
  return (
    <span className={`inline-block px-2 py-1 rounded font-heading text-xs font-semibold ${colorMap[color]} ${className}`}>
      {children}
    </span>
  );
} 